import classNames from 'classnames';
import React, { useEffect, useRef, useState } from 'react';
import { CloseIco } from '../../assets/customIcons';
import { useOnClickOutside } from '../../hooks/useOutsideClick';
import IButton from '../IButton';
import styles from './styles.module.scss'

const IModal = ({
  title,
  children,
  text,
  setOpen,
  link,
  onClick,
  position
}) => {
  
  return (
    <div 
      ref={link} 
      className={classNames(styles.modal,
       position ? styles[position] : null
      )}
    >
      <div className={styles.modalHead}>
        <h2 className={styles.title}>{title}</h2>
        <button className={styles.close} onClick={() => setOpen(false)}>
          <CloseIco />
        </button>
      </div>
      <div className={styles.modalBody}>
        {children}
      </div>
      {onClick && text &&
      <div className={styles.modalFooter}>
        <IButton onClick={onClick}>{text}</IButton>
      </div>
      }
    </div>
  );
};

export default IModal;